module.exports = __webpack_public_path__ + "img/zamowienia.6dc17e5f.svg";